// Load all symbols and add them to symbols.svg
require.context('../../symbols', true, /\.svg$/);
// require.context('../../../node_modules/bootstrap-icons/icons', true, /\.svg$/);
